import React, { useState } from "react";
import MyProfile from "../components/Carrer/MyProfile";
import Aside from "../modules/SideNav/Aside";

function MyProfileLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <MyProfile handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default MyProfileLayout;
